<template>
    <div id="app">
        <image-picker />
    </div>
</template>

<style lang="stylus">
    html, body {
        padding 0
        margin 0
        font-family "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif
        color #5e6d82
    }

    #app {
        padding 0
        margin 0
    }
</style>

<script>
  import ImagePicker from './components/ImagePicker'

  export default {
    name: 'App',
    components: { ImagePicker }
  }
</script>
